import _assertThisInitialized from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { deprecatedFunction as t } from "./deprecate.js";
import r from "./Logger.js";
import { get as e } from "./accessorSupport/get.js";
import { getOwnClassMetadata as s } from "./accessorSupport/metadata.js";
import o from "./accessorSupport/Properties.js";
import { set as c } from "./accessorSupport/set.js";
import { removeTarget as i, watch as n } from "./accessorSupport/watch.js";
import { property as a } from "./accessorSupport/decorators/property.js";
import { subclass as _ } from "./accessorSupport/decorators/subclass.js";

function u(t) {
  if (null == t) return {
    value: t
  };
  if (Array.isArray(t)) return {
    type: [t[0]],
    value: null
  };

  switch (typeof t) {
    case "object":
      return t.constructor && t.constructor.__accessorMetadata__ || t instanceof Date ? {
        type: t.constructor,
        value: t
      } : t;

    case "boolean":
      return {
        type: Boolean,
        value: t
      };

    case "string":
      return {
        type: String,
        value: t
      };

    case "number":
      return {
        type: Number,
        value: t
      };

    case "function":
      return {
        type: t,
        value: null
      };

    default:
      return;
  }
}

var p = /*#__PURE__*/function () {
  function p() {
    _classCallCheck(this, p);

    if (this.constructor === p) throw new Error("[accessor] cannot instantiate Accessor. This can be fixed by creating a subclass of Accessor");

    for (var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++) {
      t[_key] = arguments[_key];
    }

    Object.defineProperty(this, "__accessor__", {
      enumerable: !1,
      value: new o(this)
    }), t.length > 0 && this.normalizeCtorArgs && (this.__accessor__.ctorArgs = this.normalizeCtorArgs.apply(this, t));
  }

  _createClass(p, [{
    key: "postscript",
    value: function postscript(t) {
      var r = this.__accessor__,
          e = r.ctorArgs || t;
      r.initialize(), e && (this.set(e), r.ctorArgs = null), r.constructed(), this.initialize();
    }
  }, {
    key: "initialize",
    value: function initialize() {}
  }, {
    key: "destroy",
    value: function destroy() {
      this.destroyed || (i(this), this.__accessor__.destroy());
    }
  }, {
    key: "initialized",
    get: function get() {
      return this.__accessor__ && this.__accessor__.initialized || !1;
    }
  }, {
    key: "constructed",
    get: function get() {
      return this.__accessor__ && 2 === this.__accessor__.lifecycle || !1;
    }
  }, {
    key: "destroyed",
    get: function get() {
      return this.__accessor__ && this.__accessor__.destroyed || !1;
    }
  }, {
    key: "commitProperty",
    value: function commitProperty(t) {
      this.get(t);
    }
  }, {
    key: "get",
    value: function get(t) {
      return e(this, t);
    }
  }, {
    key: "hasOwnProperty",
    value: function hasOwnProperty(t) {
      return this.__accessor__ ? this.__accessor__.has(t) : Object.prototype.hasOwnProperty.call(this, t);
    }
  }, {
    key: "isInstanceOf",
    value: function isInstanceOf(e) {
      return t(r.getLogger(this.declaredClass), "isInstanceOf", {
        replacement: "Use instanceof directly",
        version: "4.16"
      }), this instanceof e;
    }
  }, {
    key: "keys",
    value: function keys() {
      return this.__accessor__ ? this.__accessor__.keys() : [];
    }
  }, {
    key: "set",
    value: function set(t, r) {
      return c(this, t, r), this;
    }
  }, {
    key: "watch",
    value: function watch(t, r, e) {
      return n(this, t, r, e);
    }
  }, {
    key: "_clearOverride",
    value: function _clearOverride(t) {
      return this.__accessor__.clearOverride(t);
    }
  }, {
    key: "_override",
    value: function _override(t, r) {
      return this.__accessor__.override(t, r);
    }
  }, {
    key: "_isOverridden",
    value: function _isOverridden(t) {
      return this.__accessor__.isOverridden(t);
    }
  }, {
    key: "notifyChange",
    value: function notifyChange(t) {
      this.__accessor__.notifyChange(t);
    }
  }, {
    key: "_get",
    value: function _get(t) {
      return this.__accessor__.internalGet(t);
    }
  }, {
    key: "_set",
    value: function _set(t, r) {
      return this.__accessor__.internalSet(t, r), this;
    }
  }], [{
    key: "createSubclass",
    value: function createSubclass() {
      var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (Array.isArray(t)) throw new Error("Multi-inheritance unsupported since 4.16");
      var r = t.properties,
          e = t.declaredClass,
          o = t.constructor;
      delete t.declaredClass, delete t.properties, delete t.constructor;
      var c = this;

      var i = /*#__PURE__*/function (_c) {
        _inherits(i, _c);

        var _super = _createSuper(i);

        function i() {
          var _this;

          _classCallCheck(this, i);

          for (var _len2 = arguments.length, t = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            t[_key2] = arguments[_key2];
          }

          _this = _super.call.apply(_super, [this].concat(t)), _this.inherited = null, o && o.apply(_assertThisInitialized(_this), t);
          return _this;
        }

        return i;
      }(c);

      s(i.prototype);

      var _loop = function _loop(_s) {
        var r = t[_s];
        i.prototype[_s] = "function" == typeof r ? function () {
          var e = this.inherited;
          var o;

          this.inherited = function () {
            for (var _len4 = arguments.length, t = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
              t[_key4] = arguments[_key4];
            }

            if (c.prototype[_s]) return c.prototype[_s].apply(this, t);
          };

          try {
            for (var _len3 = arguments.length, t = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
              t[_key3] = arguments[_key3];
            }

            o = r.apply(this, t);
          } catch (i) {
            throw this.inherited = e, i;
          }

          return this.inherited = e, o;
        } : t[_s];
      };

      for (var _s in t) {
        _loop(_s);
      }

      for (var _s2 in r) {
        var _t = u(r[_s2]);

        a(_t)(i.prototype, _s2);
      }

      return _(e)(i);
    }
  }]);

  return p;
}();

export { p as default };